import connect from 'local/test/actions/connect';
import configure from 'local/test/actions/configure';
import start from 'local/test/actions/start';
import cancel from 'local/test/actions/cancel';
import reset from 'local/test/actions/reset';

export default {
	CONNECTING: connect,
	CONFIGURING: configure,
	STARTING: start,
	CANCELING: cancel,
	RESETTING: reset,
};
